import React from "react";
import styles from "./HomePageCustomiser.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Products from "./Products";

const HomePageCustomiser = () => {
  return (
    <>
      <div className={styles.section}>
        <Products />
      </div>
      <TooltipGlodal />
    </>
  );
};

export default HomePageCustomiser;
